import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Eye, File, RefreshCw, Trash2, Upload } from "lucide-react";

const DocUploadDialogSection = ({ ctx }) => {
  const {
    docFile,
    docType,
    docUploadDialogOpen,
    handleDeleteDocument,
    handleDocUpload,
    handleViewDocument,
    isMasterAdmin,
    selectedInwardForDocs,
    setDocFile,
    setDocType,
    setDocUploadDialogOpen,
    uploadingDoc
  } = ctx;
  return (
    <>
      <Dialog open={docUploadDialogOpen} onOpenChange={setDocUploadDialogOpen}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle className="font-heading text-xl">
              GRN DOCUMENTS - {selectedInwardForDocs?.grn_number}
            </DialogTitle>
          </DialogHeader>
          
          <div className="space-y-4 mt-4">
            {/* Existing Documents */}
            {selectedInwardForDocs?.documents?.length > 0 && (
              <div className="space-y-2">
                <p className="text-xs font-medium text-slate-700 uppercase tracking-widest">Uploaded Documents</p>
                <div className="space-y-2 max-h-48 overflow-y-auto">
                  {selectedInwardForDocs.documents.map((doc) => (
                    <div key={doc.id} className="flex items-center justify-between p-3 bg-slate-50 rounded-sm border">
                      <div className="flex items-center space-x-3">
                        <File className="w-5 h-5 text-primary" />
                        <div>
                          <p className="text-sm font-medium">{doc.name}</p>
                          <p className="text-xs text-slate-500">{doc.type} • {new Date(doc.uploaded_at).toLocaleDateString()}</p>
                        </div>
                      </div>
                      <div className="flex items-center space-x-2">
                        <button
                          onClick={() => handleViewDocument(doc)}
                          className="p-1 hover:bg-primary/10 rounded text-primary"
                          title="View Document"
                        >
                          <Eye className="w-4 h-4" />
                        </button>
                        {isMasterAdmin && (
                          <button
                            onClick={() => handleDeleteDocument(selectedInwardForDocs.id, doc.id)}
                            className="p-1 hover:bg-red-100 rounded text-error"
                            title="Delete Document"
                          >
                            <Trash2 className="w-4 h-4" />
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            
            {/* Upload New Document */}
            <div className="border-t pt-4">
              <p className="text-xs font-medium text-slate-700 uppercase tracking-widest mb-3">Upload New Document</p>
              <div className="space-y-3">
                <div>
                  <label className="block text-xs font-medium text-slate-600 mb-1">Document Type</label>
                  <select
                    value={docType}
                    onChange={(e) => setDocType(e.target.value)}
                    className="w-full px-3 py-2 border border-slate-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-primary text-sm"
                  >
                    <option value="Invoice">Invoice / Bill</option>
                    <option value="Challan">Delivery Challan</option>
                    <option value="Weighment">Weighment Slip</option>
                    <option value="Quality">Quality Certificate</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-medium text-slate-600 mb-1">Select File</label>
                  <input
                    type="file"
                    accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                    onChange={(e) => setDocFile(e.target.files[0])}
                    className="w-full px-3 py-2 border border-slate-300 rounded-sm focus:outline-none text-sm file:mr-3 file:py-1 file:px-3 file:rounded-sm file:border-0 file:text-sm file:bg-primary/10 file:text-primary"
                  />
                  <p className="text-xs text-slate-500 mt-1">PDF, JPG, PNG, DOC (Max 10MB)</p>
                </div>
              </div>
            </div>
            
            <div className="flex justify-end space-x-3 pt-4">
              <button onClick={() => setDocUploadDialogOpen(false)} className="btn-outline">Cancel</button>
              <button 
                onClick={handleDocUpload} 
                disabled={!docFile || uploadingDoc}
                className="btn-primary flex items-center space-x-2 disabled:opacity-50"
              >
                {uploadingDoc ? (
                  <>
                    <RefreshCw className="w-4 h-4 animate-spin" />
                    <span>Uploading...</span>
                  </>
                ) : (
                  <>
                    <Upload className="w-4 h-4" />
                    <span>Upload Document</span>
                  </>
                )}
              </button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default DocUploadDialogSection;
